<!-- Оборачивает форму создания трекера телематики в базовую модалку -->
<template>
  <base-modal
    :visible="visible"
    title="Добавление трекера"
    size="lg"
    @close="$emit('cancel')"
  >
    <TelemetryTrackerForm
      :is-loading="isLoading"
      @save="$emit('save', $event)"
      @cancel="$emit('cancel')"
    />
  </base-modal>
</template>

<script>
import TelemetryTrackerForm from "@/components/Telemetry/TelemetryTrackerForm.vue";

export default {
  name: "TelemetryTrackerCreateModal",

  components: {
    TelemetryTrackerForm,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["save", "cancel"],
};
</script>
